import _Button from "@arco-design/web-react/es/Button";
import _Divider from "@arco-design/web-react/es/Divider";
import _Link from "@arco-design/web-react/es/Link";
import _Grid from "@arco-design/web-react/es/Grid";
import _Drawer from "@arco-design/web-react/es/Drawer";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import { IconLeft, IconToTop } from '@arco-design/web-react/icon';
import ThemePublish from '../../themePublish';
import PreviewContent from './content';
import ToggleTheme from '../toggleTheme';
import style from '../style.less';
import useLocale from '@src/hooks/useLocale';
import locale from '../locale';
export default function Preview(props) {
  var t = useLocale(locale).t;
  var _a = __read(useState(false), 2),
    visible = _a[0],
    setVisible = _a[1];
  var closeDrawer = function closeDrawer() {
    setVisible(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(props.children, {
    onClick: function onClick(e) {
      setVisible(true);
      props.children.props.onClick && props.children.props.onClick(e);
    }
  }), /*#__PURE__*/React.createElement(_Drawer, {
    bodyStyle: {
      padding: 0,
      overflow: 'hidden'
    },
    mask: false,
    width: "100%",
    mountOnEnter: true,
    footer: null,
    headerStyle: {
      height: 61,
      display: 'block',
      paddingLeft: 12
    },
    closable: false,
    title: /*#__PURE__*/React.createElement(_Grid.Row, {
      justify: "space-between",
      align: "center",
      style: {
        height: 60
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(_Link, {
      onClick: closeDrawer,
      style: {
        fontSize: 16,
        fontWeight: 500,
        color: 'var(--color-text-1)'
      }
    }, /*#__PURE__*/React.createElement(IconLeft, {
      style: {
        fontSize: 20,
        verticalAlign: '-5px'
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: 12
      }
    }, t['preview.action.back'])), /*#__PURE__*/React.createElement(_Divider, {
      type: "vertical"
    }), /*#__PURE__*/React.createElement("span", null, props.themeInfo.themeName, t['preview.pkgname.text'])), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/React.createElement(ToggleTheme, null), /*#__PURE__*/React.createElement(_Divider, {
      type: "vertical",
      className: style.divider
    }), /*#__PURE__*/React.createElement(_Link, {
      hoverable: false,
      className: style['help-doc-link'],
      href: "/docs/designlab/guideline",
      target: "_blank"
    }, t['preview.action.guideline']), /*#__PURE__*/React.createElement(_Divider, {
      type: "vertical",
      className: style.divider
    }), /*#__PURE__*/React.createElement(ThemePublish, null, /*#__PURE__*/React.createElement(_Button, {
      type: "primary",
      shape: "round",
      size: "large"
    }, /*#__PURE__*/React.createElement(IconToTop, null), t['preview.action.publish'])))),
    style: {
      transform: 'translateX(0)'
    },
    visible: visible,
    onCancel: closeDrawer
  }, /*#__PURE__*/React.createElement(PreviewContent, {
    themeInfo: props.themeInfo,
    visible: visible
  })));
}